import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import Pagination from '../../components/pagination';

const dateFormat = 'L LT';

class CancelOrderModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ordersPerPage: 10,
      currentPage: 1,
      currentPair: '',
    };
    this.setCurrentPage = this.setCurrentPage.bind(this);
  }

  setCurrentPage(number) {
    const { currentPage } = this.state;
    if (currentPage !== number) {
      this.setState({
        currentPage: number,
      });
    }
  }

  render() {
    const { orders, exchA, exchB } = this.props;
    const { ordersPerPage, currentPage } = this.state;

    let indexOfLastOrder;
    let indexOfFirstOrder;
    let currentOrders;
    let ordersLength;

    if (orders && orders.open) {
      indexOfLastOrder = currentPage * ordersPerPage;
      indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
      currentOrders = orders.open.slice(indexOfFirstOrder, indexOfLastOrder);
      ordersLength = orders.open.length;
    }

    const tableLoop = currentOrders && currentOrders.map((order, index) => {
      return (
        <tr key={index} className={order.status === 'QUEUED' ? 'order-queued' : ''}>
          <td>{moment.unix(order.createdAt).format(dateFormat)}</td>
          <td>{order.value}</td>
          <td>{order.quantity}</td>
          <td>{order.type}</td>
          <td>
            <FontAwesomeIcon
              style={{
                color: 'rgb(255, 99, 51)',
              }}
              size="lg"
              icon={faTimes}
              className={'del-icon'}
              onClick={() => this.props.orderDelete(order.referenceId)}
            />
          </td>
        </tr>
      );
    });

    return (
      <div className="cell small-12 medium-12 large-12">
        <div className="grid-x">
          <div className="cell small-12 medium-12 large-12">
            <div className="modal-heading">Cancel open orders</div>
            <div className="modal-subheading">
              Click a red cross icon to cancel the order.
            </div>
          </div>

          <div className="cell small-12 medium-12 large-12">
            {currentOrders && currentOrders.length ? (
              <div>
                <table>
                  <thead>
                    <tr>
                      <th>Created At</th>
                      <th>Price ({exchB})</th>
                      <th>Volume Remaining {exchA === 'gold' && '(grams)'}</th>
                      <th>Order Type</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {tableLoop}
                  </tbody>
                </table>
                <Pagination
                  rowsPerPage={ordersPerPage}
                  totalRows={ordersLength}
                  setCurrentPage={this.setCurrentPage}
                  currentPage={currentPage}
                />
              </div>
            ) : (
              <div>
                <table>
                  <thead>
                    <tr>
                      <th>Created At</th>
                      <th>Price ({exchB})</th>
                      <th>Volume Remaining {exchA === 'gold' && '(grams)'}</th>
                      <th>Order Type</th>
                      <th></th>
                    </tr>
                  </thead>
                </table>
                <h3 className="no-data">No Open Orders</h3>
              </div>
            )}
          </div>

          <div className="cell small-12 medium-12 large-12 modal-actions">
            <button className="button" type="submit" onClick={() => this.props.toggleModal(null)}>
              <span>
                Close
              </span>
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  orders: state.order,
});

export default connect(mapStateToProps)(CancelOrderModal);
